import {
    EXPAND,
    LEGATO,
    ROLL,
    DELAY} from './transformations.js';
import {findStep} from './utils.js';
import {delay} from './delay.js';
import {expand} from './expand.js';
import {legato} from './legato.js';
import {roll} from './roll.js';
import {shouldTransform} from './stepGroups.js';
import StepBucket from "pattern/StepBucket.js";
import {DELETE_STEP} from '../constants.js';

export default superclass => class extends superclass  {
    transformedStepBuckets = [];
    isTransformed = false;

    get stepGroups() {
        return this.track.stepGroups;
    }

    transform() {
        this.isTransformed = true;
        // find any transformations
        let stepBuckets = [...this.stepBuckets];
        let stepGroups = this.getAllGroups();
        for (let group of stepGroups) {
            for (let transformation of group.transformations) {
                if (shouldTransform(transformation)) {
                    stepBuckets = applyTransform(stepBuckets, group, transformation);
                }
            }
        }
        this.transformedStepBuckets = stepBuckets;
    }

    getAllGroups() {
        return Array.from(new Set(
            this.getAllSteps().map(x=>x.group)))
            .filter(x => x);
    }
}


const applyTransform = (stepBuckets, group, transformation) => {
    switch (transformation.thenType) {
    case DELAY:
        return delay(group, stepBuckets, transformation.thenValue.get());
    case EXPAND:
        return expand(group, stepBuckets, transformation.thenValue.get());
    case ROLL:
        return roll(group, stepBuckets);
    case LEGATO:
        return legato(group, stepBuckets);
    }
    return stepBuckets;
}

